export default __webpack_public_path__ + "static/media/search-a3a09b.b55b13d2.svg";